import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-select-dropdown',
  templateUrl: './select-dropdown.component.html',
  styleUrl: './select-dropdown.component.scss',
  standalone: false
})
export class SelectDropdownComponent {
  @Output() searchCategoryChange = new EventEmitter<string>();
  @Input() dropdownLabel: string = "";
  @Input() ariaLabelSelect: string = "";
  @Input() searchCategory: string = "";
  @Input() options: { value: string; label: string }[] = [];

  onCategoryChange(event: Event): void {
    const target = event.target as HTMLSelectElement | null;
    const category = target?.value;

    this.searchCategory = category || "";
    this.searchCategoryChange.emit(category || "");
  }
}
